import "App.css";
import "./Option.css";

type Props = {
  value: string | number;
  backgroundColorClass?: string;
  classNames?: string[];
  rightMostOption?: boolean;
  showBorder?: boolean;
};

const Option = ({
  value,
  backgroundColorClass = "",
  classNames = [],
  rightMostOption = false,
  showBorder = false,
}: Props) => (
  <div
    className={`option ${backgroundColorClass} ${classNames.join(" ")} ${
      rightMostOption ? "no-margin-right" : ""
    }`}
    style={{ ...(showBorder ? { border: "2px solid black" } : {}) }}
  >
    {value}
  </div>
);

export default Option;
